import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** How long the welcome message shows before forwarding. */
export const WELCOME_REDIRECT_MS = 1500;

/**
 * Landing page for a new invitee, which forwards to the dashboard.
 */
export default function WelcomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/', { replace: true }), WELCOME_REDIRECT_MS);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-page">
      <p role="status" className="text-lg font-semibold text-bark-900 dark:text-stone-100">
        You&apos;re in — taking you to your dashboard…
      </p>
    </div>
  );
}
